import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a11bae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-info-wrap cm-form-info-grid" }
const _hoisted_2 = { class: "cm-form-item" }
const _hoisted_3 = { class: "cm-form-item" }
const _hoisted_4 = { class: "cm-form-item" }
const _hoisted_5 = { class: "cm-form-item" }
const _hoisted_6 = { class: "cm-form-item" }
const _hoisted_7 = { class: "cm-form-item" }
const _hoisted_8 = { class: "cm-form-item" }
const _hoisted_9 = { class: "cm-form-item" }
const _hoisted_10 = {
  key: 0,
  class: "cm-form-item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "防御功能", -1))
const _hoisted_12 = {
  key: 1,
  class: "cm-form-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "防护策略", -1))
const _hoisted_14 = { class: "cm-form-item" }
const _hoisted_15 = { class: "cm-form-item" }
const _hoisted_16 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_17 = {
  key: 0,
  style: {"font-size":"14px"},
  class: "el-icon-loading"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.computerName')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.computer_name || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.fieldWanIp')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.client_ip || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalVersion')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.version || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalStatus')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.terminalLoginLabelMap[_ctx.compData.login_status] || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.lastOfflineTime')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeStamp(_ctx.compData.last_offline_time) || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.currentBootTime')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeStamp(_ctx.compData.current_startup_time) || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.todayOnlineDuration')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatDuration(_ctx.compData.today_online_time) || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.fieldUniqueId')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.device_id || '--'), 1)
    ]),
    (0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.DefenseStatusLabel[_ctx.compData.defense] || '--'), 1)
        ]))
      : _createCommentVNode("", true),
    (0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_ctx.compData.strategy_name || '--'), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.fieldRunningTasks')), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["cm-link-light", { disable: !_ctx.compData.task_count }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.compData.task_count && _ctx.changTab('issueStrategy')))
      }, _toDisplayString(_ctx.compData.task_count), 3)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.fieldAccountsSection')), 1),
      _createVNode(_component_el_table, {
        style: {"width":"auto"},
        "original-style": "",
        data: _ctx.compData.accounts,
        "empty-text": _ctx.$t('common.noData')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: _ctx.$t('groupClient.terminalInfoDetail.colIndex')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('groupClient.terminalInfoDetail.colAccount'),
            width: "200"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('listColumns.status'),
            width: "80"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.accountStatusLabelMap[scope.row.status]) + "  ", 1),
                ([_ctx.AccountStatus.enabling, _ctx.AccountStatus.disabling].includes(scope.row.status))
                  ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('listColumns.operation'),
            width: "70"
          }, {
            default: _withCtx((scope) => [
              ([_ctx.AccountStatus.enabling, _ctx.AccountStatus.disabling].includes(scope.row.status))
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "--"))
                : (scope.row.status === 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["cm-link-light", { disable: _ctx.compData.login_status !== _ctx.TerminalLoginStatus.online }]),
                      title: _ctx.compData.login_status !== _ctx.TerminalLoginStatus.online ? _ctx.tipOnlineOnly : '',
                      style: {"color":"red"},
                      onClick: ($event: any) => (_ctx.compData.login_status === _ctx.TerminalLoginStatus.online && _ctx.disableAccount(scope.row))
                    }, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.actionDisable')), 11, _hoisted_19))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: _normalizeClass(["cm-link-light", { disable: _ctx.compData.login_status !== _ctx.TerminalLoginStatus.online }]),
                      title: _ctx.compData.login_status !== _ctx.TerminalLoginStatus.online ? _ctx.tipOnlineOnly : '',
                      onClick: ($event: any) => (_ctx.compData.login_status === _ctx.TerminalLoginStatus.online && _ctx.enableAccount(scope.row))
                    }, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.actionEnable')), 11, _hoisted_20))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "empty-text"])
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}